// JS dependency
var bootstrapslider = require('bootstrap-slider');

// CSS dependency
import '/../node_modules/bootstrap-slider/dist/css/bootstrap-slider.css';

$(".range-init").each(function () {
    $(this).slider({
        tooltip: 'hide'
    }).on("change", function (slideEvt) {
        if (slideEvt.value !== undefined) {
            $(this).next().find('.value.min .txt').text(slideEvt.value.newValue[0]);
            $(this).next().find('.value.max .txt').text(slideEvt.value.newValue[1]);
        }
    });

    $(this).next().find('.value.min .txt').text($(this).data('value').split(',')[0]);
    $(this).next().find('.value.max .txt').text($(this).data('value').split(',')[1]);

});

var $slidersLabel = $(".slider-label");
$slidersLabel.slider();
$slidersLabel.on("change", function (slideEvt) {
    if (slideEvt.value !== undefined) {
        $('#' + $(this).data('slider-label-id')).text(slideEvt.value.newValue);
    }
})
